import { MDX } from '../components/mdx';

export function Markdown({ node }: any) {
  return <MDX content={node.markdown} _node />;
}
